/**
 * Group detail page tab identifiers.
 *
 * Extracted from page.tsx so the tab-value contract is unit-testable without
 * importing the heavy page component (MWBI-910). The group-activity email
 * deep-links to `/groups/<id>?tab=forum#forum-<topicDocumentId>`, so `'forum'`
 * MUST remain a valid tab value here or that link silently falls back to the
 * default tab.
 */
export type TabType = 'posts' | 'forum' | 'events' | 'videos' | 'jobs' | 'members';

export const TAB_TYPES: readonly TabType[] = [
  'posts',
  'forum',
  'events',
  'videos',
  'jobs',
  'members',
];

export function isTabType(value: string | null): value is TabType {
  return value !== null && (TAB_TYPES as readonly string[]).includes(value);
}
